import angular from 'angular';
import {
  loaderService,
  ssDialogService,
  assetDataService,
} from 'app/services';
import {
  alerts,
  confirmDialog,
} from 'app/components/global';
import controller from './sync-assetType-dialog.controller';
import template from './sync-assetType-dialog.html';
import syncAsset from '../../syncAsset';


class dialogService {
  getOptions($event, {
    // eslint-disable-next-line no-shadow
    assetType,
  }) {
    return {
      controller,
      controllerAs: 'syncAssetTypeVM',
      locals: {
        assetType,
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.assetAdmin.syncAssetType', [
  loaderService,
  alerts,
  confirmDialog,
  ssDialogService,
  assetDataService,
  syncAsset
])
  .service('syncAssetTypeDialog', dialogService)
  .name;
